// For legacy block support
// import 'slick-carousel';
// import initFeatherlight from 'featherlight'
// initFeatherlight();
import './legacy-blocks';

import './blog';
import './home-loading';
import './home-hero-video';
import './navigation';
import './responsive-spacers';
import './search';
import './fslightbox-3.6.0';
import htmx from 'htmx.org';
import Splide from '@splidejs/splide';

htmx.config.globalViewTransitions = true;

document.addEventListener('DOMContentLoaded', function () {
    // Do stuff
});
